import { i18n } from "../../../i18n//i18n";

import "./styles.css";
import { useMemo, useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useRef } from "react";
import { languagesObjectsEnabled } from "../../../utils/languagesObjectsEnabled";

function Internacionalization() {
  const [opened, setOpened] = useState(false);
  const openedRef = useRef(opened);
  const langs = useMemo(() => {
    return languagesObjectsEnabled();
  }, []);
  const currentLang = useMemo(() => {
    return langs.find((lang) => lang.locale === i18n.locale);
  }, [langs]);

  function changeLanguage(lang) {
    localStorage.setItem("@Lang", lang);
    document.location.reload();
  }

  useEffect(() => {
    openedRef.current = opened;
  }, [opened]);

  useEffect(() => {
    const close = () => {
      if (openedRef.current) {
        setOpened(false);
      }
    };

    document.addEventListener("click", close);

    return () => {
      document.removeEventListener("click", close);
    };
  }, []);

  const handleOpen = useCallback(
    (event) => {
      event.stopPropagation();

      setOpened(!opened);
    },
    [opened],
  );

  return (
    <div className="internacionalization-container">
      <div className="internacionalization-content">
        <div onClick={handleOpen} className={`selected ${opened ? "opened" : "closed"}`}>
          <img src={`/images/${currentLang?.icon}`} alt="Idioma" />
          <p>{currentLang?.name}</p>
        </div>

        {opened && (
          <div className="options">
            {langs.map((lang) => (
              <div onClick={() => changeLanguage(lang.locale)} className="option">
                <img src={`/images/${lang.icon}`} alt="Idioma" />
                <p>{lang.name}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Internacionalization;
